import {getDashApiHealthUrl} from './installDashApiFetchGuard';
import {writeStoredServiceBootId} from './serviceEpochStorage';

/**
 * ponytail: interval poll removed — restart detection during active editing is
 * covered by installDashApiFetchGuard (every response). captureServiceEpochFromHealth
 * is called once on login / session restore. Upgrade path: re-add setInterval only
 * if truly-idle-tab restart detection becomes required.
 */
export function startServiceEpochGuard() {
    return () => {};
}

export async function captureServiceEpochFromHealth() {
    if (typeof window === 'undefined') {
        return null;
    }
    try {
        const res = await fetch(getDashApiHealthUrl(), {
            method: 'GET',
            headers: {Accept: 'application/json'},
            cache: 'no-store',
        });
        if (!res.ok) {
            return null;
        }
        const headerBootId = res.headers.get('x-dash-boot-id');
        const data = await res.json().catch(() => ({}));
        const bootId = headerBootId || data?.bootId;
        if (bootId) {
            writeStoredServiceBootId(bootId);
            return bootId;
        }
    } catch (_) {
        // ignore
    }
    return null;
}
